/**
 * Wheel Configurator Slider
 * ------------------------------------------------------------------------------
 * A script to control the Wheel Config slider.
 *
 * @namespace wheelConfigSlider
 */
import log from 'salvo-lite/log'

import {on} from '../../helpers/utils'
import cssClasses from '../../helpers/cssClasses'

class WcSlider {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            carSliderItem: '[js-car-slider=item]',
            carSliderCar: '[js-car-slider-item=car]',
            carSliderTyre: '[js-car-slider-item=tyre]',
            mobileStartBtn: '[js-button=mobile-start]',
            navItem: '[js-slider-nav-item]',
            formBackButton: '[js-button=back]',
            ...JSON.parse(elem.getAttribute('data-wc-slider') || '{}')
        }

        /**
         * Node selectors.
         */
        this._nodeSelectors = {
            carImageContainer: document.querySelectorAll(this._settings.carImageContainer),
            carColourInputs: document.querySelectorAll(this._settings.carColourInputs)
        }

        /**
         * Global variables.
         */
        this._carImageSlider = this._theme.getComponentsById('wheel-config-carousel')._carousel

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise accordion component.
     */
    onInit () {
        this._setListeners()
        this._setClickEvents()
    }

    /**
     * Set listeners for the event bus
     */
    _setListeners () {
        window.Frame.EventBus.listen('WheelConfig:tyresLoaded', () => this._initCarSlider())
        window.Frame.EventBus.listen('WheelConfig:formActive', () => this._zoomCarImage())
    }

    /**
     * Set clickable events
     */
    _setClickEvents () {
        // Nav thumbnails
        this._nodeSelectors.navItem.forEach((item) => {
            on('click', item, () => {
                this._activateSelectedItem(item)
                this._showSlide(item)
            })
        })

        // Mobile start button
        on('click', this._nodeSelectors.mobileStartBtn, () => {
            window.Frame.EventBus.emit('WheelConfig:formActive')
        })

        // Form back button
        on('click', this._nodeSelectors.formBackButton, function () {
            this._showSlide(this)
        })
    }

    /**
     * Add a class to the image slider to zoom the image & disable flickity functionality - only on mobile
     */
    _zoomCarImage () {
        this._elem.classList.add(cssClasses.zoomed)
        this._nodeSelectors.carSliderTyre.classList.add(cssClasses.hidden)
    }

    /**
     * Show slide.
     * @param {Object} item the element to show.
     */
    _showSlide (item) {
        this._carImageSlider.select(item.dataset.slide, false, false)
    }

    /**
     * Add active class to element that is clicked and remove from other items
     * @param {Object} element the clicked element
     */
    _activateSelectedItem (element) {
        this._nodeSelectors.navItem.forEach((item) => {
            if (item === element) {
                if (!element.classList.contains(cssClasses.active)) {
                    element.classList.add(cssClasses.active)
                }
            } else {
                item.classList.remove(cssClasses.active)
            }
        })
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // });
}

export default WcSlider



// WEBPACK FOOTER //
// ./src/resources/scripts/components/wheel-config/WcSlider.js